import Vue from 'vue'
import axios from 'axios'
import Rails from '@rails/ujs'

Vue.use({
  install (Vue) {
    const instance = axios.create()

    instance.interceptors.response.use(
      response => response,
      error => {
        if (error.response?.status === 401) {
          Rails.ajax({
            url: '/timeout',
            type: 'GET',
            dataType: 'script',
            success: function() { window.location.href = '/accounts/sign_in' }
          })
        } else {
          return Promise.reject(error)
        }
      })

    Vue.prototype.$http = instance
  }
})
